import { css } from "@emotion/react";
import { theme } from "styles/theme";

interface BackgroundProps {
  gradientColorFrom: string;
  gradientColorTo: string;
}

export const FuncUserStyle = {
  auth: {
    index: css`
      background-color: rgba(114, 114, 114, 1);
    `,
    content: css`
      padding: 6px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    `,
    info: css`
      /* width: 30%; */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 16px;
      .points {
        color: rgb(252 143 0 / 1);
        cursor: pointer;
        width: 100%;
        text-align: center;

        display: flex;
        align-items: center;
        gap: 4px;
      }
      .username {
        color: #fff;
        margin-top: 6px;
        font-size: 12px;
      }
    `,
    menu: css`
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      .item-menu {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 8px;
        text-decoration: none;
        text-transform: uppercase;

        .icon {
          height: 30px;

          img {
            height: 100%;
          }
        }

        p {
          color: #fff;
          font-size: 11px;
          margin-top: 4px;
        }
      }
    `,
  },
  noLogin: {
    fcUser: {
      index: css`
        display: flex;
      `,
      item: ({ gradientColorFrom, gradientColorTo }: BackgroundProps) => css`
        background: linear-gradient(
          90deg,
          ${gradientColorFrom} 0%,
          ${gradientColorTo} 100%
        );
        width: 50%;
        padding: 10px 0;

        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        text-transform: uppercase;
        color: ${theme.colors.white};
      `,
    },
  },
};
